var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m448 488h-192l96-176z",
    fill: "#a0815c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 312-96 176h-208l96-176z",
    fill: "#5f4d37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 456 28 28",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 480 24-24",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 184a40 40 0 0 0 40 40h104a32 32 0 1 0 0-64c-.46 0-.93.01-1.39.03a52.006 52.006 0 0 0 -94.9-15.28 40 40 0 0 0 -47.71 39.25z",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 96,
    fill: "#ff9811",
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m458.912 45.088-5.657 5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.745 141.255-5.657 5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.912 146.912-5.657-5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.745 50.745-5.657-5.657"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496 480h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 352a8 8 0 0 0 -8 8v105a8 8 0 0 0 16 0v-105a8 8 0 0 0 -8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.66 450.34a8.015 8.015 0 0 0 -11.32 0l-19.26 19.27-88.06-161.44a7.991 7.991 0 0 0 -7.02-4.17h-208a7.991 7.991 0 0 0 -7.02 4.17l-88.06 161.44-19.26-19.27a8 8 0 1 0 -11.32 11.32l18.35 18.34h-20.69a8 8 0 0 0 0 16h448a8 8 0 0 0 0-16h-4.69l18.35-18.34a8.015 8.015 0 0 0 0-11.32zm-416.18 29.66 87.27-160h189.77l-87.27 160zm208 0 82.52-151.29 82.52 151.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81 232h104a40 40 0 0 0 4.685-79.728 60.023 60.023 0 0 0 -104.809-16.115q-1.937-.157-3.876-.157a48 48 0 0 0 0 96zm0-80a32.108 32.108 0 0 1 6.171.6 8.009 8.009 0 0 0 8.35-3.655 44.007 44.007 0 0 1 80.3 12.916 8.036 8.036 0 0 0 8.144 6.16c.342-.015.691-.022 1.033-.022a24 24 0 0 1 0 48h-103.998a32 32 0 0 1 0-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 144a48 48 0 1 0 -48-48 48.053 48.053 0 0 0 48 48zm0-80a32 32 0 1 1 -32 32 32.036 32.036 0 0 1 32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 40a8 8 0 0 0 8-8v-8a8 8 0 0 0 -16 0v8a8 8 0 0 0 8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 160v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464 96a8 8 0 0 0 8 8h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 104h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.255 58.745a7.974 7.974 0 0 0 5.657-2.343l5.657-5.657a8 8 0 1 0 -11.314-11.314l-5.655 5.657a8 8 0 0 0 5.657 13.657z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.088 135.6-5.657 5.657a8 8 0 0 0 11.314 11.314l5.657-5.657a8 8 0 1 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.912 135.6a8 8 0 1 0 -11.312 11.312l5.657 5.657a8 8 0 1 0 11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.088 56.4a8 8 0 1 0 11.312-11.312l-5.657-5.657a8 8 0 1 0 -11.314 11.314z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamping);
export default __webpack_public_path__ + "static/media/camping.83afe9d62161f3919463211e0265d53a.svg";
export { ForwardRef as ReactComponent };